// Notification bridge — Option D.
// Call sites remain unchanged: notification['error']({ message: 'Title', description: '...' })
// Internally translates antd v5 `message` key → antd v6 `title` key.
// Instance is injected by <NotificationBridge> mounted inside <App>.

let _instance = null;

export function _setNotificationInstance(instance) {
    _instance = instance;
};

function buildArgs(args) {
    if (!args || typeof args !== 'object') return args;
    const { message, ...rest } = args;
    return message !== undefined ? { title: message, ...rest } : rest;
};

function call(method, args) {
    if (!_instance) {
        console.error('[notification] Bridge not ready — notification dropped:', method, args);
        return;
    }
    _instance[method](buildArgs(args));
};

const notification = {
    success: (args) => call('success', args),
    error: (args) => call('error', args),
    warning: (args) => call('warning', args),
    info: (args) => call('info', args),
    open: (args) => call('open', args),
};

// Bracket-notation support: notification['error']({...})
// notification['success'] = notification.success;
// notification['error'] = notification.error;
// notification['warning'] = notification.warning;
// notification['info'] = notification.info;
// notification['open'] = notification.open;

export default notification;
